import { useCallback } from 'react';
import { useFetcher } from '@remix-run/react';
import { COMMENT_MARK_AS_READ_API_ROUTE } from '~/routes/remix-api.app.build-hub-comment-mark-as-read';

/**
 * Hook to mark a document's comments as read.
 * Returns a function that can be called with a document ID.
 */
export function useCommentMarkAsRead() {
    const fetcher = useFetcher();

    const markAsRead = useCallback(
        (documentID: string) => {
            const formData = new FormData();
            formData.append('documentID', documentID);

            fetcher.submit(formData, {
                method: 'post',
                action: COMMENT_MARK_AS_READ_API_ROUTE,
            });
        },
        [fetcher]
    );

    return {
        markAsRead,
        loading: fetcher.state !== 'idle',
    };
}
